import { useMutation } from '@tanstack/react-query'
import { createShortVideo } from '../../service/list'

function useCreateShortVideo() {
  return useMutation({
    mutationKey: ['create-short-video'],
    mutationFn: createShortVideo,
  })
}

export default useCreateShortVideo
